import { render } from "./ProgrammingTech.vue?vue&type=template&id=1b9cb95e"
import script from "./ProgrammingTech.vue?vue&type=script&lang=js"
export * from "./ProgrammingTech.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__